import * as React from 'react';
import { Space } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import reactJsonView from 'react-json-view';
import { TestCaseTurn, AgentInfo } from '@interface/index';
import { getUserInfo, getAgentInfo, isEqual } from '@lib/index';

import './index.less';
import { createAgentPayload } from '@page/intent/common-apis';
const chatBotIcon = require('@static/image/icons/chat_bot.jpg');
const ReactJson = reactJsonView;

function tryItNowSession({ turns, channel, expectedTurns }: {
  turns: TestCaseTurn[];
  channel: string;
  expectedTurns?: TestCaseTurn[];
}) {

  return <div
    id="try-it-now-session-wrap"
    className="tryitnow-session-wrap"
  >
    {turns.map((turn: TestCaseTurn, index: number) => {

      const reply: any = turn.reply && parseReply(turn.reply, channel);

      const state = JSON.parse(turn.stateInfo || '{}');
      const agent: AgentInfo | undefined = getAgentInfo();

      const expectedTurn = expectedTurns && expectedTurns.length > index && expectedTurns[index];

      const re: any = expectedTurn && parseReply(expectedTurn.reply, channel);

      const se = expectedTurn && JSON.parse(expectedTurn.stateInfo || '{}');

      const diff = expectedTurn && !isEqual(se.session, state.session);
      // const diff = expectedTurn && !isEqual(re, reply);


      return <div key={`turn-wrap-${index}`} style={{ width: '100%', marginTop: 12 }}>
        {
          turn.query &&
          <div key="user-query" className="user-query" style={{ marginBottom: 12 }}>
            <span>
              <pre className="session-text-wrap">
                {turn.query}
              </pre>
            </span>

            <span style={{ marginLeft: 16 }}>
              <img width="24px" src={getUserInfo().headimgurl} />
            </span>
          </div>
        }
        {
          turn.structureInput &&
          <div key="user-structure-input" className="user-query">
            <pre className="session-text-wrap">
              <div>Structure Event:</div>
              {turn.structureInput}
            </pre>

            <span style={{ marginLeft: 16 }}>
              <img width="24px" src={getUserInfo().headimgurl} />
            </span>
          </div>
        }
        {reply &&
          <div
            key="bot-reply"
            className="chat-bot-reply"
          >
            <img className="icon-img" key="bot-img" src={agent && agent.iconUrl || chatBotIcon} />
            <span key="bot-content" className="reply-content-wrap">

              {reply.length > 0 &&
                <div key="bot-reply">
                  <span style={{ display: 'inline-block' }}>
                    <pre className="session-text-wrap" dangerouslySetInnerHTML={{ __html: reply }}>
                    </pre>
                  </span>
                </div>
              }
              <div key="du-title"><span>State</span></div>
              <div key="bot-du">
                <span className="json-view-wrap" style={{ display: 'inline-block' }}>
                  <ReactJson
                    src={state}
                    style={{ backgroundColor: '#f5f5f5' }}
                    name={false}
                    displayObjectSize={false}
                    displayDataTypes={false}
                    collapsed
                  />
                </span>
              </div>
              {diff &&
                <div key="expected" style={{ marginTop: 16 }}>
                  <h4 style={{ color: 'red' }}>Expected</h4>
                  {re.length > 0 &&
                    <div key="bot-reply">
                      <span style={{ display: 'inline-block' }}>
                        <pre className="session-text-wrap" dangerouslySetInnerHTML={{ __html: re }}>
                        </pre>
                      </span>
                    </div>
                  }

                  <div key="du-title">State</div>
                  <div key="bot-du" className="json-view-wrap">
                    <span className="json-view-wrap" style={{ display: 'inline-block' }}>
                      <ReactJson
                        style={{ background: '#f5f5f5' }}
                        src={se}
                        name={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                      />
                    </span>
                  </div>
                </div>
              }
            </span>
          </div>
        }
      </div>;
    })}
  </div >;
}

function parseReply(reply: any, channel: string) {
  let re: any = JSON.parse(reply);
  re = re && (re[channel] || re['*']);

  let tmp = '';

  (re || []).forEach((obj: any) => {
    if (typeof obj === 'string') {
      if (tmp.length > 0) {
        tmp = tmp + '\n';
      }

      const result = obj.match(/^\[([0-9a-zA-Z_.]+)\]/);

      const matchText = result &&
        result.length >= 2 &&
        result[1];

      const newText = obj.replace(`[${matchText}]`, `<span style="color: rgba(0, 0, 0, 0.52); padding: 1px 6px;vertical-align:middle; margin-right: 8px;border-radius:2px;font-size:12px;border: 1px solid rgba(0, 0, 0, 0.26)">${matchText}</span>`);

      tmp = tmp + newText;
    } else if (obj.type === 'text') {
      let text = obj.payload && obj.payload.text || obj.text;

      if (text && text.length > 0) {


        const result = text.match(/\[([0-9a-zA-Z_.]+)\]/);

        const matchText = result &&
          result.length >= 2 &&
          result[1];

        text = text.replace(`[${matchText}]`, `<span style="color: rgba(0, 0, 0, 0.52); padding: 1px 6px;vertical-align:middle; margin-right: 8px;border-radius:2px;font-size:12px;border: 1px solid rgba(0, 0, 0, 0.26)">${matchText}</span>`);


        if (tmp.length > 0) {
          tmp = tmp + '\n';
        }

        tmp = tmp + text;
      }
    }
  });

  return tmp;
}

export const TryItNowSession = tryItNowSession;
